export default __webpack_public_path__ + "static/media/IFA.06ab1e54.svg";